module.exports = __webpack_public_path__ + "static/media/paper-money-input.71070785.svg";